import { createActions } from 'reduxsauce';

const { Types: types, Creators: actions } = createActions({
    // add group
    requestSubmitGroup: ['id', 'data'],
    submitGroupSucceeded: ['data'],
    submitGroupFailed: ['errors'],

    // clear state
    clearGroupCreateState: null,
});

export default {
    // add group
    [types.REQUEST_SUBMIT_GROUP]: (state) => ({
        ...state,
        create: {
            ...state.create,
            submitting: true,
            errors: null,
        },
    }),
    [types.SUBMIT_GROUP_SUCCEEDED]: (state, { data }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            groupDetails: data,
            success: true,
        },
    }),
    [types.SUBMIT_GROUP_FAILED]: (state, { errors }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            success: false,
            errors,
        },
    }),

    // clear state
    [types.CLEAR_GROUP_CREATE_STATE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            groupDetails: null,
            success: false,
            errors: null,
        },
    }),
};

export { types, actions };